const SECTION_SELECTOR = ".meet-the-founders";

const addDotBtnsAndClickHandlers = (emblaApi, dotsNode, templateNode) => {
  let dotNodes = [];

  const addDotBtnsWithClickHandlers = () => {
    dotsNode.innerHTML = "";
    const slideCount = emblaApi.scrollSnapList().length;

    for (let index = 0; index < slideCount; index += 1) {
      const dotNode = templateNode.content.firstElementChild.cloneNode(true);
      dotNode.addEventListener("click", () => {
        emblaApi.scrollTo(index);
      });
      dotsNode.appendChild(dotNode);
    }

    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
  };

  const toggleDotBtnsActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();

    dotNodes[previous]?.classList.remove("embla__dot--selected");
    dotNodes[selected]?.classList.add("embla__dot--selected");
  };

  emblaApi
    .on("init", addDotBtnsWithClickHandlers)
    .on("reInit", addDotBtnsWithClickHandlers)
    .on("init", toggleDotBtnsActive)
    .on("reInit", toggleDotBtnsActive)
    .on("select", toggleDotBtnsActive);

  addDotBtnsWithClickHandlers();
  toggleDotBtnsActive();
};

const CARD_TAIL_HEIGHT = 16;
const CARD_HEIGHT = 369.509765625;

const equalizeCardHeightsAndSyncViewport = (emblaApi, sectionNode, viewportNode) => {
  viewportNode.style.height = `${CARD_HEIGHT + CARD_TAIL_HEIGHT}px`;
};

const GAP_SPACER_ATTR = "data-gap-spacer";

const clearDistributedGaps = (card) => {
  card.querySelectorAll(`[${GAP_SPACER_ATTR}]`).forEach((el) => {
    el.style.marginBottom = "";
    el.removeAttribute(GAP_SPACER_ATTR);
  });
};

// Measures against the attribution's own bottom edge, not scrollHeight — the card's absolutely-positioned corner notch sits outside the padding box and would skew scrollHeight.
const MAX_HEADING_GAP = 40;

const measureCardGap = (card) => {
  const heading = card.querySelector(".meet-the-founders__card-heading");
  const description = card.querySelector(".meet-the-founders__card-description");
  const attribution = card.querySelector(".meet-the-founders__card-attribution");
  const lastContentEl = attribution || description;
  if (!heading || !description || !lastContentEl) return null;

  const cardRect = card.getBoundingClientRect();
  const lastContentRect = lastContentEl.getBoundingClientRect();
  const cardPaddingBottom = parseFloat(getComputedStyle(card).paddingBottom) || 0;
  const naturalHeight = lastContentRect.bottom - cardRect.top + cardPaddingBottom;

  const leftover = cardRect.height - naturalHeight;
  if (leftover <= 1) return null;

  const currentMargin = parseFloat(getComputedStyle(heading).marginBottom) || 0;
  return { heading, marginBottom: Math.min(currentMargin + leftover, MAX_HEADING_GAP) };
};

const applyCardGap = ({ heading, marginBottom }) => {
  heading.style.marginBottom = `${marginBottom}px`;
  heading.setAttribute(GAP_SPACER_ATTR, "true");
};

const distributeAllCardGaps = (sectionNode) => {
  const cards = Array.from(sectionNode.querySelectorAll(".meet-the-founders__card"));

  cards.forEach(clearDistributedGaps); // must precede measuring, or a prior run's margin would skew it
  const plans = cards.map(measureCardGap).filter(Boolean); // reads only
  plans.forEach(applyCardGap); // writes only
};

const initializeSection = (sectionNode) => {
  const emblaNode = sectionNode.querySelector(".embla");
  const viewportNode = emblaNode?.querySelector(".embla__viewport");
  if (!emblaNode || !viewportNode) return;

  if (typeof EmblaCarousel === "undefined") {
    console.error("EmblaCarousel library not loaded");
    return;
  }

  const dotsNode = sectionNode.querySelector(".meet-the-founders__dots");
  const templateNode = sectionNode.querySelector(".meet-the-founders__dot-template");
  const emblaApi = EmblaCarousel(viewportNode, {
    breakpoints: {
      "(min-width: 768px)": { active: false },
    },
  });

  if (dotsNode && templateNode) {
    addDotBtnsAndClickHandlers(emblaApi, dotsNode, templateNode);
  }

  if (window.innerWidth < 768) {
    equalizeCardHeightsAndSyncViewport(emblaApi, sectionNode, viewportNode);
  }

  distributeAllCardGaps(sectionNode);

  // Re-measure after fonts load — an early measurement can under-count leftover space before text reflows.
  if (document.fonts?.ready) {
    document.fonts.ready.then(() => distributeAllCardGaps(sectionNode));
  }
  setTimeout(() => distributeAllCardGaps(sectionNode), 300);

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth < 768) {
        equalizeCardHeightsAndSyncViewport(emblaApi, sectionNode, viewportNode);
      }
      distributeAllCardGaps(sectionNode);
    }, 150);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const sectionNodes = document.querySelectorAll(SECTION_SELECTOR);
  sectionNodes.forEach((sectionNode) => {
    initializeSection(sectionNode);
  });
});
